import Main from '@/views/Main.vue';

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: '登录 - 律师好帮手App电脑端 '
    },
    component: () => import('@/views/main/login/login.vue')
};
export const loginRouter3 = {
    path: '/login',
    name: 'login',
    meta: {
        title: '登录 - 律师好帮手App电脑端 '
    },
    component: () => import('@/views/main/login/login3.vue')
};

export const page403 = {
    path: '/403',
    meta: {
        title: '403-权限不足'
    },
    name: 'error-403',
    component: () => import('@/views/main/error-page/403.vue')
};

export const page500 = {
    path: '/500',
    meta: {
        title: '500-服务端错误'
    },
    name: 'error-500',
    component: () => import('@/views/main/error-page/500.vue')
};

export const registRouter = {
    path: '/register',
    name: 'register',
    meta: {
        title: '注册 - XBoot前后端分离开发平台'
    },
    component: () => import('@/views/app/register.vue')
};

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('@/views/main-components/lockscreen/components/locking-page.vue')
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
    path: '/',
    name: 'otherRouter',
    redirect: '/home',
    component: Main,
    children: [
        { path: 'home', title: { i18n: 'home' }, name: 'home_index', component: () => import('@/views/main/home/home.vue') },
        { path: 'ownspace', title: '个人中心', name: 'ownspace_index', component: () => import('@/views/main/own-space/own-space.vue') },
        { path: 'change-pass', title: '修改密码', name: 'change_pass', component: () => import('@/views/main/change-pass/change-pass.vue') },
        { path: 'change-email', title: '修改邮箱', name: 'change_email', component: () => import('@/views/main/change-email/change-email.vue') },
        { path: 'message', title: '消息中心', name: 'message_index', component: () => import('@/views/main/message/message.vue') }
    ]
};

export const appRouter = [];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    // 普通登录
    // loginRouter,
    // 扫码登录
    loginRouter3,
    registRouter,
    otherRouter,
    locking,
    ...appRouter,
    page500,
    page403
];
